import React from "react";
import { getBrandLogo } from "../../utils/userDetailsUtils";
import nogruntblacklogo from "../../Assets/nogruntblacklogo.svg";

const LoaderSpinner = ({
  size = "md",
  // logo = null,
  showLogo = true,
  text = "",
  overlay = false,
  overlayZIndex = 1400,
  overlayBackgroundColor = "rgba(245, 247, 249, 0.72)",
  overlayBlur = "2px",
  overlayClassName = "",
  className = "",
  barHeight = "h-1",
  barColor = "bg-black",
  backgroundColor = "bg-gray-200",
}) => {
  const logoToShow = getBrandLogo(nogruntblacklogo);
  const sizeVariants = {
    xs: "w-24",
    sm: "w-32",
    md: "w-48",
    lg: "w-64",
    xl: "w-96",
    full: "w-full",
  };

  const logoSizeVariants = {
    xs: "h-4",
    sm: "h-6",
    md: "h-8",
    lg: "h-10",
    xl: "h-12",
    full: "h-10",
  };

  // The ring is absolutely positioned, so the box it sits in needs its own size - without one it
  // collapses to nothing as soon as the logo is not rendered.
  const spinnerContent = (
    <div className="flex flex-col items-center gap-4">
      <div className={`relative flex items-center justify-center ${showLogo ? "w-24 h-24" : "w-12 h-12"}`}>
        <div
          className={`absolute inset-0 border-gray-300 border-t-indigo-700 rounded-full animate-spin ${
            showLogo ? "border-[5px]" : "border-[3px]"
          }`}
        />
        {showLogo && (
          <img
            src={logoToShow}
            alt="Logo"
            className="h-10 w-auto object-contain drop-shadow-md"
          />
        )}
      </div>

      {text && <div className="text-sm text-gray-700 tracking-wide text-center">{text}</div>}
    </div>
  );

  if (!overlay) {
    return spinnerContent;
  }

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center ${overlayClassName}`}
      style={{
        zIndex: overlayZIndex,
        backgroundColor: overlayBackgroundColor,
        backdropFilter: overlayBlur ? `blur(${overlayBlur})` : "",
      }}
    >
      {spinnerContent}
    </div>
  );
};

export default LoaderSpinner;
